import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import CSSModules from 'react-css-modules';
import {autobind} from 'core-decorators';
import IconButton from 'components/common/material/IconButton';
import purchaseDocumentUrl from 'utils/url/purchaseDocumentUrl';
import * as purchaseConstants from './constants';
import styles from './purchaseInbox.scss';

const iconTheme = {
  icon: styles.purchaseInboxIcon
};

@CSSModules(styles, {allowMultiple: true})
class PurchaseInbox extends React.Component {

  static propTypes = {
    purchase: PropTypes.object.isRequired,
    userState: PropTypes.string
  };

  constructor() {
    super();
    this.state = {
      purchaseInboxItemsOpen: false
    };
  }

  @autobind
  componentDidMount() {
    this.hideOnPageClick = (e) => {
      const elem = ReactDOM.findDOMNode(this);
      if (!this.state.purchaseInboxItemsOpen || elem.contains(e.target)) {
        return;
      }
      this.setState({purchaseInboxItemsOpen: false});
    };

    window.addEventListener('mousedown', this.hideOnPageClick, false);
    window.addEventListener('touchend', this.hideOnPageClick, false);
  }

  @autobind
  componentWillUnmount() {
    window.removeEventListener('mousedown', this.hideOnPageClick);
    window.removeEventListener('touchend', this.hideOnPageClick);
  }


  @autobind
  toggleMenu() {
    this.setState(() => ({purchaseInboxItemsOpen: !this.state.purchaseInboxItemsOpen}));
  }

  render() {
    const commonData = {
      externalId: this.props.purchase.externalId,
      purchaseState: this.props.purchase.retailerState,
      userState: this.props.userState
    };

    const originator = this.props.purchase.originator;
    const amountWasModified = this.props.purchase.amountWasModified;

    const purchaseDocuments = purchaseConstants.purchaseDocuments.filter ((purchaseDocument) => {
      if (purchaseDocument.documentType ==='com.sunbit.notification.purchase.Agreement.RIC' && originator === purchaseConstants.originators.TAB) {
        return false;
      }

      if (purchaseDocument.documentType ==='com.sunbit.notification.purchase.Agreement.TAB' && originator === purchaseConstants.originators.MERCHANT) {
        return false;
      }

      if (purchaseDocument.documentType ==='com.sunbit.notification.purchase.Agreement.California_Privacy' && commonData.purchaseState !== 'CA') {
        return false;
      }

      if (purchaseDocument.documentType ==='com.sunbit.notification.purchase.Agreement.GLBA.TAB' && originator !== purchaseConstants.originators.TAB) {
        return false;
      }

      if (purchaseDocument.documentType ==='com.sunbit.notification.purchase.TILA.TILA' && !amountWasModified) {
        return false;
      }

      if (purchaseDocument.documentType ==='com.sunbit.notification.loan.payment.disclosure' && commonData.purchaseState !== 'HI' && commonData.userState !== 'HI'){
        return false;
      }

      return true;
    });

    const purchaseInboxItems = purchaseDocuments.map((purchaseDocument, index) => {
      let notification = purchaseDocument.notification;
      let documentType = purchaseDocument.documentType;
      if (originator === purchaseConstants.originators.TAB) {
        if (notification === 'com.sunbit.notification.purchase.Agreement') {
          notification = 'com.sunbit.notification.purchase.Agreement.TAB';
        }
      }
      else if (documentType === 'com.sunbit.notification.purchase.Agreement.RIC' && commonData.purchaseState === 'AZ') {
        documentType = documentType + '.' + commonData.purchaseState;
      }

      const data = {
        ...commonData,
        notification: notification,
        documentType: documentType,
      };
      return (
        <div key={index} styleName="purchaseInboxItem"><a href={purchaseDocumentUrl(data)} target="_blank">{purchaseDocument.name}</a></div>
      );
    });

    return (
      <div styleName="purchaseInbox">
        <IconButton data-label="documents" icon="email" theme={iconTheme} styleName="purchaseInboxIconWrap" onMouseDown={this.toggleMenu}/>
        {this.state.purchaseInboxItemsOpen && <div styleName="purchaseInboxItems">{purchaseInboxItems}</div>}
      </div>
    );
  }
}

export default PurchaseInbox;



// WEBPACK FOOTER //
// ./src/purchases/PurchaseInbox.js